export default __webpack_public_path__ + "static/media/11.24b3b592.jpg";